export default "__VITE_ASSET__cddba956__"